export function isUserRoleAssignmentResponse(value) {
    if (!value || typeof value !== 'object')
        return false;
    const item = value;
    return (typeof item.userId === 'string' &&
        typeof item.displayName === 'string' &&
        typeof item.email === 'string' &&
        ['provisioned', 'active', 'disabled'].includes(item.status ?? '') &&
        Number.isInteger(item.rolesVersion) &&
        (item.rolesVersion ?? 0) > 0 &&
        Array.isArray(item.roles) &&
        item.roles.every((role) => typeof role.id === 'string' &&
            typeof role.code === 'string' &&
            typeof role.name === 'string' &&
            typeof role.description === 'string' &&
            typeof role.isSystem === 'boolean' &&
            typeof role.assigned === 'boolean' &&
            Array.isArray(role.permissions) &&
            role.permissions.every((permission) => typeof permission === 'string')) &&
        Array.isArray(item.effectivePermissions) &&
        item.effectivePermissions.every((permission) => typeof permission === 'string'));
}
